module.exports = false;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_library.js
// module id = 57
// module chunks = 2 3 4 5 6 7 8 9 10 11 12